function parseTime(time,format='Y-M-D'){    	
  let date = new Date(time);
  let year = date.getFullYear();
  let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let day = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());

  let hours = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
  let minutes = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
  let seconds = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
  
  format = format.toLowerCase()

  format = format.replace('y', year);
  format = format.replace('m', month);
  format = format.replace('d', day);
  format = format.replace('h', hours);
  format = format.replace('m', minutes);
  format = format.replace('s', seconds);

  return format
}

export {
  parseTime
}